import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Observable } from "rxjs";
import {
  ListOfPractitionerEvents,
  PractitionerEvent,
} from "../core/model/v2/practitioner/practitioner-event";
import { PracticeService } from "../core/services/v2/practice.service";
import { UtilsService } from "../core/services/v2/utils.service";
import { PhysicianOptionService } from "../physician/shared/physician-option/physician-option.service";

@Injectable({
  providedIn: "root",
})
export class PhysicianEventService {
  pageLength = 10;
  pageIndex = 1;
  dataLength;
  practitionerEventsList: PractitionerEvent[] = [];


  constructor(
    private physicianOptionService: PhysicianOptionService,
    private practiceService: PracticeService,
    private utils: UtilsService
  ) { }

  getevents() {
    this.getPractitionerEvents().subscribe((e) => {
      this.practitionerEventsList = e.practitionerEventResponses;
      this.dataLength = e.totalRecords;
      if (this.dataLength < (this.pageIndex - 1) * this.pageLength)
        this.pageIndex = 1;
    });
  }
  getPractitionerEvents(): Observable<ListOfPractitionerEvents> {
    const observable = new Observable<ListOfPractitionerEvents>((observer) => {
      const practitionerId = this.physicianOptionService.getPhysician().id;
      const pageIndex = this.pageIndex;
      const itemsCount = this.pageLength;

      if (practitionerId === undefined) {
        return;
      }

      this.practiceService
        .getPractitionerEvents(practitionerId, pageIndex, itemsCount)
        .subscribe(
          (res) => {
            if (res.response.isSuccess) {
              //dataSource=res.
              observer.next(res);
              observer.complete();
            } else {
              //this.utils.showMessageSnackBar("An error occur to load event data. Try again later", true);
            }
            observer.error();
          },
          (error) => {
            console.error(error);
            observer.error(error);
          }
        );
    });

    return observable;
  }
}
